import { Box } from '@mui/material';
import { DialogWrapper } from '../../../../shared/components/common/dialogWrapper';
import { FsButton } from '../../../../shared/components/button';
import { useEffect } from 'react';
import { useState } from 'react';
import { ConfirmationDialogHelpers } from '../../../../helpers/confirmationDialogHelper';
import { useTranslation } from 'react-i18next';

export const ConfirmAutoInvestDialog = ({
	state,
	bucket,
	onClose = (e) => {},
}) => {
	const [options, setOptions] = useState({});
	const { t } = useTranslation();
	useEffect(() => {
		const tempOptions = !bucket
			? ConfirmationDialogHelpers.getManualBucketOptions(t)
			: ConfirmationDialogHelpers.getBucketOptions(t, bucket);
		setOptions(tempOptions.data);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bucket]);

	const getMessage = () => {
		return options?.message;
	};

	return (
		<DialogWrapper
			hideCloseBtn={true}
			maxWidth="xs"
			width={'400px'}
			state={state}
			title={options?.title}
			onClose={() => {
				onClose(false);
			}}
			content={
				<>
					<Box className="flex justify-center items-center">
						<p
							dangerouslySetInnerHTML={{
								__html: `${getMessage()}`,
							}}
							className="!sub-title-text text-center"></p>
					</Box>
				</>
			}
			actions={
				<Box className="flex items-center justify-center w-full">
					<FsButton
						fullWidth
						onClick={() => {
							onClose(true);
						}}>{options?.positiveText}</FsButton>
					<FsButton
						className="!mx-2"
						fullWidth
						variant="outline"
						onClick={() => {
							onClose(false);
						}}>{options?.negativeText}</FsButton>
				</Box>
			}></DialogWrapper>
	);
};
